import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

/**
 * Optional pattern validator — only validates if the control value is non-empty.
 */
export function optionalPattern(pattern: RegExp, key: string): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    if (!value || value === '') return null;
    return pattern.test(String(value)) ? null : { [key]: true };
  };
}

// eslint-disable-next-line no-control-regex
export const BRAND_NUMBER_UNSAFE_CHARACTER = /['"`;#?%&*^|\\<>[\]{}\u0000-\u001F\u007F]/;
// eslint-disable-next-line no-control-regex
export const BRAND_NUMBER_INVALID_CHARACTERS = /['"`;#?%&*^|\\<>[\]{}\u0000-\u001F\u007F]/g;

/** Removes characters that must not be entered in a brand-number field. */
export function sanitizeBrandNumber(value: unknown): string {
  return String(value ?? '').replace(BRAND_NUMBER_INVALID_CHARACTERS, '');
}

/**
 * Optional brand-number validator — rejects characters known to be unsafe for the brand-number field.
 */
export function optionalBrandNumber(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    if (!value || value === '') return null;
    return BRAND_NUMBER_UNSAFE_CHARACTER.test(String(value)) ? { brandNumberUnsafeCharacter: true } : null;
  };
}

/**
 * Optional integer range validator — only validates if the control value is non-empty.
 */
export function optionalInteger(min: number, max: number): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    if (value === null || value === undefined || value === '') return null;
    const num = Number(value);
    if (!Number.isInteger(num)) return { integer: true };
    if (num < min) return { min: true };
    if (num > max) return { max: true };
    return null;
  };
}

/**
 * Optional number validator (≥ min) — only validates if the control value is non-empty.
 */
export function optionalNumber(min: number): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    if (value === null || value === undefined || value === '') return null;
    const num = Number(value);
    if (isNaN(num)) return { number: true };
    if (num < min) return { min: true };
    return null;
  };
}
